import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Typography } from "@material-tailwind/react";
import useAuth from "../hooks/useAuth";

const TeacherRoute = () => {
  const { isAuth, user } = useAuth();
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (user?.role !== "teacher" || user?.isAdmin === true || !user?.studioAccess) {
    return (
      <div className="mx-auto mt-16 max-w-3xl rounded-2xl border border-amber-200 bg-amber-50 px-6 py-10 text-center">
        <Typography variant="h4" className="text-amber-900">
          Teacher access required
        </Typography>
        <Typography className="mt-3 text-amber-800">
          Your account can still use all student features. Ask an administrator to grant Teacher Studio access before opening this area.
        </Typography>
      </div>
    );
  }

  return <Outlet />;
};

export default TeacherRoute;
